import React from 'react'
import styles from './TableStats.module.css';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { IoMdStats } from "react-icons/io";
// import GameIconButton from '../GameIconButton/GameIconButton';
import { GameIconButton } from '@themed-components';

// Example mock stats
const mockStats = [
    { id: 1, label: 'Hands Played', value: 42 },
    { id: 2, label: 'VPIP', value: '28%' },
    { id: 3, label: 'PFR', value: '19%' },
    { id: 4, label: 'Biggest Pot', value: '₹1,200' },
    { id: 5, label: 'Showdown %', value: '54%' },
];

export default function TableStats({ tempTableId }) {
    // Replace mockStats with real data when available
    const stats = mockStats; // or [] for empty state

    return (
        <Sheet>
            <SheetTrigger className={styles.filterButton}>
                <GameIconButton>
                    <IoMdStats />
                </GameIconButton>
            </SheetTrigger>
            <SheetContent side="right" className={styles.gameMenuSheetContent}>
                <div className={styles.header}>Table Stats</div>
                <div className={styles.list}>
                    {stats.length === 0 ? (
                        <div className={styles.empty}>No stats available yet.</div>
                    ) : (
                        stats.map(stat => (
                            <div key={stat.id} className={styles.statItem}>
                                <span className={styles.statLabel}>{stat.label}</span>
                                <span className={styles.statValue}>{stat.value}</span>
                            </div>
                        ))
                    )}
                </div>
            </SheetContent>
        </Sheet>
    )
}
